<template>
  <div class="echarts-block">
    <div class="echarts-contant" :id="chart_id">
    </div>
  </div>
</template>

<script>
  let echarts = require('echarts')
  export default {
    name: 'echarts',
    props: ['chart_id', 'option'],
    data () {
      return {
        chart: null
      }
    },
    watch: {
      option () {
        this.setOption()
      }
    },
    mounted () {
      this.chart = echarts.init(document.getElementById(this.chart_id))
      this.setOption()
    },
    methods: {
      setOption () {
        this.chart.setOption(this.option)
      }
    }
  }
</script>

<style scoped lang="less">
  .echarts-block {
    width: 100%;
    height: 90%;
    display: inline-block;
    .echarts-contant {
      width: 100%;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// Echarts.vue?622c7a87